import {objectReducer} from '../../../shared/reducers/object-reducer';
import {RECEIVE_CHECKLIST} from './actions';

export default objectReducer({
  replaceObjectAction: RECEIVE_CHECKLIST,
  defaultState: {
    groups: [],
  },
});
